<template>
  <div
    v-if="visible"
    :class="[
      'flex justify-between font-normal text-white w-[343px] p-4 fixed bg-[#306aff] rounded-md z-30 items-center cursor-pointer left-1/2 -translate-x-1/2 transition-opacity',
      position,
    ]"
  >
    <span class="text-md">{{ message }}</span>
    <div class="flex items-center" @click="closeModal">
      <a :href="actionUrl" class="underline text-sm mr-1">
        {{ actionName }}
      </a>
      <OIcon icon="times" class="u-center w-4 h-4" />
    </div>
  </div>
</template>

<script>
import { ref, defineComponent } from '@nuxtjs/composition-api';
import { OIcon } from '~/modules/common/components/ui';

export default defineComponent({
  components: { OIcon },
  props: {
    message: {
      type: String,
      required: true,
    },
    actionName: {
      type: String,
      required: true,
    },
    actionUrl: {
      type: String,
    },
    position: {
      type: String,
      default: 'bottom-center',
    },
  },
  setup() {
    const visible = ref(true);

    const closeModal = () => {
      visible.value = false;
    };
    return { visible, closeModal };
  },
});
</script>

<style scoped>
.top-center {
  top: 20px;
}
.bottom-center {
  bottom: 20px;
}
</style>
